import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  query {
    myContributionViews {
        edges {
            node {
                id
                dbId
                template
                name
            }
        }
    }
  }
`;

export function useMyContributionViews() {
  const { data: rawData, refresh, isLoading } = useQuery(query, { fetchPolicy: 'cache-first' });
  const data = (rawData?.myContributionViews?.edges.length) > 0 ? removeConnectionsMemoized(rawData?.myContributionViews) : [];
  return {
    data,
    refresh,
    isLoading
  };
}
